import { library } from "@fortawesome/fontawesome-svg-core";
import Vue, { VueConstructor } from "vue";
import { IWinfaktVueComponentsOptions } from "./winfakt-vue-components-options";

import VCalendar from "v-calendar";
//import "v-calendar/lib/v-calendar.min.css";

export class WinfaktVueComponentsOptions {
	public static defaultDataTableSelectAllLimit:number = 0;

	public static defaultDatatableCompare: (a:any, b:any) => boolean = function(a:any, b:any):boolean {
		return a.id == b.id;
	};

	public static defaultDatatableEmptyLabel():{toString():string}{
		return "No data found";
	}

	public static installOptions(options:IWinfaktVueComponentsOptions, vue:VueConstructor<Vue>) {
		if (options.defaultDatatableCompare) {
			WinfaktVueComponentsOptions.defaultDatatableCompare = options.defaultDatatableCompare;
		}
		if (!options.ignoreCalendar) {
			vue.use(VCalendar, {firstDayOfWeek: 2, locale: "en-GB"});
		}
		if (options.iconFonts) {
			library.add(...options.iconFonts);
		}
		if (options.defaultDataTableSelectAllLimit){
			this.defaultDataTableSelectAllLimit = options.defaultDataTableSelectAllLimit;
		}
	}


}